export const TabLists: string[] = [
	"Trips",
	"Claims",
	"Transactions",
	"Vehicles",
	"Odometer",
];
